import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { DeliverCollectReportService } from '../../../services/deliver-collect-report.service';
import { ModalService } from '../../../services/modal.service';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-deliver-collect-report',
  templateUrl: './deliver-collect-report.component.html',
  styleUrls: ['./deliver-collect-report.component.css']
})
export class DeliverCollectReportComponent implements OnInit {
  modalService: ModalService;

  filter: any = {
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    quick_Search: ""
  };

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;

  availableOptions: string[] = [
    'Serial #',
    'Tag',
    'Cylinder Size',
    'Product Type',
    'Cylinder Material',
    'Customer Delivered',
    'Delivered',
    'Location Delivered',
    'Customer Collected',
    'Collected At',
    'Location Collected'
];

selectedOptions: string[] = [
  'Serial #',
  'Tag',
  'Cylinder Size',
  'Product Type',
  'Cylinder Material',
  'Delivered',
  'Location Delivered',
  'Collected At',
  'Location Collected'
];


  constructor(authService: AuthService, public deliverCollectReportService: DeliverCollectReportService, public router: Router, modalService: ModalService,
    private columnService: ColumnService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    //this.loadTable(this.page);

  }

  ngOnInit() {
    //this.loadTable(this.page);
    this.getcolumns();
    this.init = true;
  }

  outOfService() {    
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.deliverCollectReportService.getResults(this.page, this.filter.start_Date, this.filter.end_Date, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.deliverCollectReportService.getExcel(this.filter.start_Date, this.filter.end_Date).then((data) => {
        importedSaveAs(data, 'Abnormal.xlsx');
      });
  }

  gotoTop() {  
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {    
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {    
    this.columnService.getColumns(this.client.userId, "deliverCollectReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "deliverCollectReport", this.selectedOptions).then((data) => {
    });
  }
}

